module.exports = __webpack_public_path__ + "img/hotdog_hawaiiano.a67eb9ef.jpg";